//@flow
import React from 'react';
import FilterLists from './FilterLists.react';
import type { Filter, FilterCategories } from '../../Stores/Filters/filtersStoreClass';

type Props = {
  filters:FilterCategories,
  selectedFilters:Filter[],
};

const elementId = 'FilterDropdown';

export default function FilterDropdown(props:Props) {

  return (
    <div className="filter-dropdown-container" id={elementId}>
      <div className="filter-dropdown">
        <div className="filters-container">
          <FilterLists
            filters={props.filters}
            selectedFilters={props.selectedFilters}
            controlId={elementId}
          />
        </div>
      </div>
    </div>
  );
}
